import { css } from "@styled-system/css";

export const noticeClass = css({
	display: "flex",
	flexDirection: "column",
	gap: "4",
	padding: "12",
	marginBottom: "8",
	border: "1px solid",
	borderColor: "error.100",
	borderRadius: "4",
	color: "error.100",
	wordBreak: "break-word",
});

export const titleClass = css({
	fontWeight: "bold",
});

export const listClass = css({
	listStyleType: "disc",
	paddingLeft: "20",
});
